import React, { useLayoutEffect, useState } from 'react'
import { ViewProps } from 'react-native'

import { styled } from 'nativewind'

import { Icon } from '../icons'
import { XStack } from '../layout'
import { colors } from '../tailwind'
import { B5 } from '../typography'

const AlertFrame = styled(XStack, 'w-full py-4/2 px-2  items-center rounded ', {
  variants: {
    intent: {
      primary: 'bg-primary-10',
      error: 'bg-error-10',
      success: 'bg-success-10',
      warning: 'bg-warning-10',
      info: 'bg-decorative-bee-10',
    },
  },
  defaultProps: {
    intent: 'primary',
  },
})
const AlertText = styled(B5, 'text-grays-80  flex-wrap flex-1')

const RenderIcon = styled(Icon, '')

interface iconType {
  name: string
  color: string
}
interface alertProps extends ViewProps {
  intent?: string
  iconLeft?: iconType
  iconRight?: iconType
}

export const Alert: React.FC<alertProps> = ({
  intent,
  iconLeft,
  iconRight,
  ...props
}) => {
  const [iconValue, setIconValue] = useState<iconType>({
    name: '',
    color: '',
  })

  const getIconValues = (intent = 'primary') => {
    switch (intent) {
      case 'error':
        setIconValue({ name: 'ErrorFilled', color: colors.error[100] })
        break
      case 'success':
        setIconValue({ name: 'DoneOutlined', color: colors.success[100] })
        break
      case 'warning':
        setIconValue({ name: 'CautionOutlined', color: colors.warning[100] })
        break
      case 'primary':
        setIconValue({ name: 'IconPlaceHolder', color: colors.primary[100] })
        break
      case 'info':
        setIconValue({
          name: 'InfoOutlined',
          color: colors.decorative.bee[150],
        })
        break
    }
    if (iconLeft) {
      setIconValue({ name: iconLeft.name, color: iconLeft.color })
    }
  }

  useLayoutEffect(() => {
    getIconValues(intent)
  }, [intent])

  return (
    <AlertFrame intent={intent} {...props}>
      <RenderIcon
        type={iconValue.name}
        color={iconValue.color}
        className="mr-3"
      />
      <AlertText>{props.children}</AlertText>
      {iconRight && (
        <RenderIcon
          type={iconRight.name}
          color={iconRight.color}
          className="ml-2"
        />
      )}
    </AlertFrame>
  )
}
